import dynamic from "next/dynamic";

export const BlogFeed = dynamic(() => import("./component"));
